module.exports = __webpack_public_path__ + "8402ad7995c3f47a467004ec13410ba3.svg";